import { Link } from "react-router-dom"
import styled from "styled-components"
import barcodeBtnBg from "assets/images/barcode-btn-bg.png"

export const MyFoodsWrapper = styled.div`
  height: calc(100% - var(--app-top-navigation-height) - var(--profile-header-height));
  background: #fff;
  --footer-height: 68px;
`

export const MyFoodsMain = styled.div`
  height: 100%;
  padding-top: 8px;
`

export const RecentFoodsTabBtn = styled(Link)<{ $isActive: boolean }>`
  min-width: 100px;
  display: flex;
  padding: 6px 15px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.$isActive
      ? "var(--Schemes-On-Surface-Variant-2, #69757D)"
      : "var(--Schemes-Surface-Container-Low, #F5F7F7)"};

  color: ${(props) => (props.$isActive ? "#fff" : "#1C1F21")};

  font-size: 14px;
  font-weight: ${(props) => (props.$isActive ? "600" : "400")};
  line-height: 160%;
  border-radius: 20px;
  cursor: pointer;
  text-decoration: none;
`

export const BarCodeBtn = styled.div`
  background-image: url(${barcodeBtnBg});
  background-size: 100%;
  height: 40px;
  width: 100%;
  padding: var(--spacing_s, 8px) var(--spacing_m, 12px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--spacing_s, 8px);
  background-color: var(--Schemes-Primary-Container, #4bd9de);
  overflow: hidden;
  cursor: pointer;
`

export const ScanBarcodeText = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
`

export const BarcodeBetaBtn = styled.div`
  border-radius: 20px;
  border: 1px solid var(--Primary_16, rgba(13, 163, 186, 0.16));
  background: var(--Primitive-White, #fff);
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.06) inset,
    2px 2px 8px 0px rgba(0, 0, 0, 0.16);
  display: flex;
  padding: 1px 11px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-weight: 600;
  line-height: 160%;
`
